var EHDI = EHDI || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.BugManager = function() { 
    
    EHDI.aka.Container.call(this);
    
    this.lockInput = false;
    this.changeBug = false;
    
    var _bugs = new Array();
    var tileWidth, tileHeight;
    var _this = this;
    var _hand, _current, _next, _nextHand;
    var _currentAngle;
    var _speed = 1200;
    var _limit;
    var _radius = 30;
    var _colors = ["blue", "green", "pink", "purple", "red", "yellow"];
    var _foundColors = [];
    var _tileOffset = 0;
    var _moveCount = 0;
    var _progressionCount = 5;
    var _neighborOffsets = [[[1,0], [0,1], [-1,1], [-1,0],[-1,-1],[0,-1]],
                            [[1,0], [1,1], [0,1], [-1,0], [0,-1], [1,-1]]];
    var _rowCount = 2;
    var _colorCount = 3;
    var _prevPosX;
    var _prevPosY;
    var _roundCount = 0;
    
    var getWildMatchColor = function() {
        for(var i = _bugs.length - 1; i >= 0; i--) {
            for (var j = 0; j < _bugs[i].length; j++) {
                var tile = _bugs[i][j];

                if(!tile) {
                    continue;
                }

                var cluster = findCluster(j, i, true, true, false);
                if(cluster.length < 2 || _current.bugType === cluster[0].bugType) {
                    continue;
                } else {
                    return cluster[0].bugType;
                }
            }
        }
        return null;
    }
    
    this.changeCurrentBug = function() {
        EHDI.GAME.soundManager.playSFX("wild");
        var wildMatchColor = getWildMatchColor();
        if(wildMatchColor != null) {
            _current.changeBug(EHDI.Assets.images["bugout_bug_" + _colors[wildMatchColor]], _colors[wildMatchColor]);
            _current.bugType = wildMatchColor;
        } else {
            var randomizer = Math.floor(EHDI.NumberUtil.randomRange(0, _foundColors.length));
            while(_foundColors[randomizer] === _current.bugType)
                randomizer = Math.floor(EHDI.NumberUtil.randomRange(0, _foundColors.length));
            _current.changeBug(EHDI.Assets.images["bugout_bug_" + _colors[_foundColors[randomizer]]], _colors[_foundColors[randomizer]]);
            _current.bugType = _foundColors[randomizer];
        }
        
        
        
    }
    
    var changeNextBug = function(callBack) {
        EHDI.GAME.soundManager.playSFX("wild");
        var randomizer = Math.floor(EHDI.NumberUtil.randomRange(0, _foundColors.length));
        while(_foundColors[randomizer] === _next.bugType)
            randomizer = Math.floor(EHDI.NumberUtil.randomRange(0, _foundColors.length));
        _next.changeBug(EHDI.Assets.images["bugout_bug_" + _colors[_foundColors[randomizer]]], _colors[_foundColors[randomizer]], callBack);
        _next.bugType = _foundColors[randomizer];
    }
    
    this.checkIfGameOver = function() {
        if(_bugs[6]) {
            for(var i = 0; i < _bugs[6].length; i++) {
                if(_bugs[6][i]) {
                    _gizmo.texture = EHDI.Assets.images["bugout_gizmo3"];
                    EHDI.GAME.pauseButton.endGame();
                    var gameOverTimeline = new TimelineMax();
                    gameOverTimeline.addCallback(function() {
                        EHDI.GAME.gameScene.gameOver();
                    }, 0.5);
                }
            }
        }
    }
    
    var nextToCurrent = function() {
        _current = _next;
        _hand.texture = EHDI.Assets.images["bugout_gizmohand_hold"];
        EHDI.GAME.soundManager.playSFX("nextbug");
        _current.rotation = EHDI.NumberUtil.degreeToRadian(180);
        _current.position.x = _hand.x;
        generateNext();
    }
    
    this.checkIfNewRound = function() {
        var count = 0;
        for(var i = 0; i < _bugs[0].length; i++) {
            if(_bugs[0][i])
                count++;
        }
        if(count == 0) {
            if(EHDI.GAME.constants.gameLevelComplete) {
                EHDI.GAME.constants.gameLevelComplete(EHDI.GAME.constants.gameName, EHDI.GAME.gameScene.scoreHolder.getScore());   
            }
            _rowCount++;
            _rowCount = Math.min(_rowCount, 4);
            _colorCount++;
            _colorCount = Math.min(_colorCount, _colors.length);
            _bugs = new Array();
            generateBugs();
            if(_rowCount == 4)
                _progressionCount--;
            _progressionCount = Math.max(_progressionCount, 3);
            _roundCount++;
            EHDI.GAME.pauseButton.isPaused = true;
            EHDI.GAME.bgm.stop();
            EHDI.GAME.gameScene.addChild(new EHDI.components.roundClearedNotif(_roundCount));
            EHDI.GAME.gameScene.resetBugCount();
        }
        _foundColors = findColors();
        if(_foundColors.indexOf(_next.bugType) == -1) {
            changeNextBug(nextToCurrent);
        } else {
            nextToCurrent();
        }
    }
    
    var circleIntersection = function(x1,y1,x2,y2) {
        var dx = x1 - x2;
        var dy = y1 - y2;
        var len = Math.sqrt(dx * dx + dy * dy);
        
        if(len < _radius * 2) {
            return true;
        }
        
        return false;
    }
    
    var findColors = function() {
        var foundColors = [];
        var colorTable = [];
        for(var i = 0; i < 5; i++) {
            colorTable.push(false);
        }
        
        for(var i = 0; i < _bugs.length; i++) {
            for(var j = 0; j < _bugs[i].length; j++) {
                if(_bugs[i][j]) {
                    if(!colorTable[_bugs[i][j].bugType]) {
                        colorTable[_bugs[i][j].bugType] = true;
                        foundColors.push(_bugs[i][j].bugType);
                      }
                }
            }
        }
        return foundColors;
    }
    
    var resetProcessed = function () {
        for(var i = 0; i < _bugs.length; i++) {
            for(var j = 0; j < _bugs[i].length; j++) {
                if(_bugs[i][j])
                    _bugs[i][j].processed = false;
            }
        }
    }
    
    var getNeighbors = function(tile) {
        var tileGridPos = getGridPosition(tile.x, tile.y);
        
        var tileRow = (tileGridPos.y + _tileOffset) % 2;
        var neighbors = [];
        
        var n = _neighborOffsets[tileRow]
        for(var i = 0; i < n.length; i++) {
            var nx = tileGridPos.x + n[i][0];
            var ny = tileGridPos.y + n[i][1];
            
            if(ny >= 0 && ny < _bugs.length && nx >= 0 && nx < _bugs[ny].length) {
                if(_bugs[ny][nx]) {
                    neighbors.push(_bugs[ny][nx]);
                }
            }
        }
        
        return neighbors;
    }
    
    var findCluster = function(tx, ty, matchtype, reset, skipremoved) {
        if(reset)
            resetProcessed();
        
        var targetTile = _bugs[ty][tx];
        
        var toProcess = [targetTile];
        targetTile.processed = true;
        
        var foundCluster = [];
        
        while (toProcess.length > 0) {
            var currentTile = toProcess.pop();
            
            if(currentTile == null) {
                continue;
            }
            
            if(skipremoved && currentTile.removed) {
                continue;
            }
            if(!matchtype || (currentTile.bugType === targetTile.bugType)) {
                foundCluster.push(currentTile);
                var neighbors = getNeighbors(currentTile);
                for(var i = 0; i < neighbors.length; i++) {
                    if(!neighbors[i].processed) {
                        toProcess.push(neighbors[i]);
                        neighbors[i].processed = true;
                    }
                }
            }
        }
        return foundCluster;
        
    }
    
    var findFloatingClusters = function() {
        resetProcessed();
        var foundClusters = [];
        
        for(var i = 0; i < _bugs.length; i++) {
            for(var j = 0; j < _bugs[i].length; j++) {
                var tile = _bugs[i][j];
                if(tile && !tile.processed) {
                    var gridPos = getGridPosition(tile.x, tile.y);
                    var foundCluster = findCluster(gridPos.x, gridPos.y, false, false, true);
                    if(foundCluster.length <= 0)
                        continue;
                    
                    var floating = true;
                    for(var k = 0; k < foundCluster.length; k++) {
                        var clusterGridPos = getGridPosition(foundCluster[k].x, foundCluster[k].y);
                        if(clusterGridPos.y == 0) {
                            floating = false;
                            break;
                        }
                    }
                    
                    if(floating) {
                        foundClusters.push(foundCluster);
                    }
                }
            }
        }
        
        return foundClusters;
    }
    
    var addBubbles = function() {
        _tileOffset++
        
        var row = [];
        for(var j = 0; j < 12; j++) {
            var randomizer = Math.floor(EHDI.NumberUtil.randomRange(0, _colors.length));
            var newBug = new EHDI.component.Bug(EHDI.Assets.images["bugout_bug_" + _colors[randomizer]], _colors[randomizer]);
            row.push(newBug);
            tileWidth = newBug.width;
            tileHeight = newBug.height;
            var pos = getTileCoordinate(j, 0);
            newBug.position.set(pos.x, pos.y);
            newBug.bugType = randomizer;
            _this.addChild(newBug);
        }
        
        _bugs.splice(0,0, row);
        
        for(var i = 0; i <_bugs.length; i++) {
            for(var j = 0; j < _bugs[i].length; j++) {
                if(_bugs[i][j]) {
                    var pos = getTileCoordinate(j, i);
                    _bugs[i][j].position.set(pos.x, pos.y);
                }
            }
        }
        
        /*for(var i = _bugs.length; i > 0; i--) {
            for(var j = 0; j < _bugs[i-1].length; j++) {
                if(!_bugs[i]) {
                    _bugs[i] = [];
                }
                _bugs[i][j] = _bugs[i - 1][j];
                if( _bugs[i][j]) {
                    var pos = getTileCoordinate(j, i);
                    _bugs[i][j].position.set(pos.x, pos.y);
                }
            }
        }*/
        
        /*for(var i = 0; i < _bugs[0].length; i++) {
            var randomizer = Math.floor(EHDI.NumberUtil.randomRange(0, _colors.length));
            var newBug = new EHDI.aka.Sprite(EHDI.Assets.images["bugout_bug_" + _colors[randomizer]]);
            _bugs[0][i] = newBug;
            
            var pos = getTileCoordinate(i,0);
            newBug.position.set(pos.x, pos.y);
            tileWidth = newBug.width;
            tileHeight = newBug.height;
            newBug.bugType = randomizer;
            newBug.anchor.set(0.5);
            _this.addChild(newBug);
        }*/
    }
    
    var getGridPosition = function(x,y) {
        var gridY =  Math.floor(y / tileHeight);
        
        var offsetX = 0;
        if((gridY + _tileOffset) % 2) {
            offsetX = tileWidth / 2;
        }
        var gridX = Math.floor((x - offsetX) / tileWidth);
        return {x : gridX, y : gridY};
    }
    
    var checkIfAlmostDone = function() {
        var count = 0;
        for(var i =0; i < _bugs.length; i++) {
            for(var j = 0; j < _bugs[i].length; j++) {
                if(count > 5)
                    return;
                if(_bugs[i][j])
                    count++;
            }
        }
        var previousColor = null;
        var sameColorCount = 0;
        var space = 0;
        var isCluster = false;
        for(var i = 0; i < _bugs[0].length; i++) {
            if(!_bugs[0][i]) {
                if(previousColor)
                    space++;
                continue;
            }
            
            if(previousColor === null) {
                previousColor = _bugs[0][i].bugType;
            } 
            if(previousColor !== _bugs[0][i].bugType) {
                return;
            } else {
                if(space > 0)
                    return;
            }
        }
        return previousColor;
    }
    
    var generateNext = function() {
        var newColor = checkIfAlmostDone();
        // console.log(_colors[newColor]);
        if(newColor) {
            _next = new EHDI.component.Bug(EHDI.Assets.images["bugout_bug_" + _colors[newColor]], _colors[newColor]);
            _next.position.set(_nextHand.x, _nextHand.y - _nextHand.height * 0.6);
            _next.velocityX = 0;
            _next.velocityY = 0;
            _next.bugType = newColor;
            // console.log(_colors[newColor]);
            _this.addChild(_next);
        } else {
            // console.log("randomNEXT");
            var randomizer = Math.floor(EHDI.NumberUtil.randomRange(0, _foundColors.length));
            _next = new EHDI.component.Bug(EHDI.Assets.images["bugout_bug_" + _colors[_foundColors[randomizer]]], _colors[_foundColors[randomizer]]);
            _next.position.set(_nextHand.x, _nextHand.y - _nextHand.height * 0.6);
            _next.velocityX = 0;
            _next.velocityY = 0;
            _next.bugType = _foundColors[randomizer];
            _this.addChild(_next);
        }
        
    }
    
    var getTileCoordinate = function(column, row) {
        var tileX = column * tileWidth + tileWidth * 0.5;
        
        if((row + _tileOffset) % 2) {
            tileX += tileWidth / 2;
        }
        
        var tileY = row * tileHeight + tileHeight * 0.5; 
        return {x : tileX, y : tileY};
    }
    
    var generateBugs = function() {
        for(var i = 0; i < _rowCount; i++) {
            var row = [];
            for(var j = 0; j < 12; j++) {
                var randomizer = Math.floor(EHDI.NumberUtil.randomRange(0, _colorCount));
                var newBug = new EHDI.component.Bug(EHDI.Assets.images["bugout_bug_" + _colors[randomizer]], _colors[randomizer]);
                row.push(newBug);
                tileWidth = newBug.width;
                tileHeight = newBug.height;
                var pos = getTileCoordinate(j, i);
                newBug.position.set(pos.x, pos.y);
                newBug.bugType = randomizer;
                _this.addChild(newBug);
            }
            _bugs.push(row);
        }
    }
    
    generateBugs();
    _foundColors = findColors();
    
    _limit = this.width - 30;
    _hand = new EHDI.aka.Sprite(EHDI.Assets.images["bugout_gizmohand_hold"]);
    _hand.anchor.set(0.5,0.75);
    _hand.position.set(this.width * 0.5, EHDI.screen.stageHeight * 0.85);
    this.addChild(_hand);
    
    _nextHand = new EHDI.aka.Sprite(EHDI.Assets.images["bugout_gizmohand_hold"]);
    _nextHand.anchor.set(0.5,0.75);
    _nextHand.scale.set(-1, 1);
    _nextHand.position.set(this.width * 0.1, EHDI.screen.stageHeight * 0.85);
    this.addChild(_nextHand);
    
    _gizmo = new EHDI.aka.Sprite(EHDI.Assets.images["bugout_gizmo1"]);
    _gizmo.anchor.set(0.5,1);
    _gizmo.position.set(this.width * 0.3, EHDI.screen.stageHeight * 0.85);
    this.addChild(_gizmo);
    
    var randomizer = Math.floor(EHDI.NumberUtil.randomRange(0, _colorCount));
    _current = new EHDI.component.Bug(EHDI.Assets.images["bugout_bug_" + _colors[randomizer]], _colors[randomizer]);
    _current.position.set(_hand.x, _hand.y - _hand.height * 0.6);
    _current.rotation = EHDI.NumberUtil.degreeToRadian(180);
    _current.velocityX = 0;
    _current.velocityY = 0;
    _current.bugType = randomizer;
    this.addChild(_current);
    
    generateNext();
    
    this.globalPosX = _current.x;
    this.globalPosY = _current.y;
    
    this.handleMovement = function(x,y) {
        if(!_current || _this.lockInput)
            return;
        _currentAngle = EHDI.NumberUtil.radianToDegree(Math.atan2(this.globalPosY-y, x - this.globalPosX));
        _currentAngle = Math.abs(_currentAngle);
        if (Math.abs(_currentAngle) < 8) {
            _currentAngle = 8;
        } else if (Math.abs(_currentAngle) > 172) {
                _currentAngle = 172;
        }
        
        _current.rotation = -EHDI.NumberUtil.degreeToRadian(_currentAngle + 90);
    }
    
    var snapBubble = function() {
        var gridPos = getGridPosition(_current.x, _current.y);
        var snapPos = getTileCoordinate(gridPos.x, gridPos.y);
        if(gridPos.x > 12)
            return false;
        if(!_bugs[gridPos.y])
            _bugs[gridPos.y] = [];
        if(_bugs[gridPos.y][gridPos.x])
            return false;
        _current.position.set(snapPos.x, snapPos.y);
        _current.velocityX = 0;
        _current.velocityY = 0;
        _current.rotation = 0;
        _bugs[gridPos.y][gridPos.x] = _current;
        
        var cluster = findCluster(gridPos.x, gridPos.y, true, true, false);
        if(cluster.length >= 3) {
            EHDI.GAME.soundManager.playSFX("correct");
            EHDI.GAME.gameScene.scoreHolder.addScore(cluster.length * 10);
            for(var i = 0; i < cluster.length; i++) {   
                var clusterGridPos = getGridPosition(cluster[i].x, cluster[i].y);
                _this.removeChild(cluster[i]);
                _this.addChild(cluster[i]);
                cluster[i].fly();
                _moveCount = 0;
                _bugs[clusterGridPos.y][clusterGridPos.x] = null;
                _gizmo.texture = EHDI.Assets.images["bugout_gizmo1"];
                
            }
        } else {
            _moveCount++;
            _this.lockInput = false;
            if(_moveCount >= _progressionCount) {
                addBubbles();
                _moveCount = 0;
                _gizmo.texture = EHDI.Assets.images["bugout_gizmo2"];
            } else if(_moveCount == _progressionCount - 1) {
                _gizmo.texture = EHDI.Assets.images["bugout_gizmo3"];
            } else {
                _gizmo.texture = EHDI.Assets.images["bugout_gizmo2"];
            }
        
            _current = _next;
            _hand.texture = EHDI.Assets.images["bugout_gizmohand_hold"];
            EHDI.GAME.soundManager.playSFX("nextbug");
            _current.rotation = EHDI.NumberUtil.degreeToRadian(180);
            _current.position.x = _hand.x;
            _foundColors = findColors();
            generateNext();
            _this.checkIfGameOver();
        }
        
        var floatCluster = findFloatingClusters();
        for(var i = 0; i < floatCluster.length; i++) {
            for(var j = 0; j < floatCluster[i].length; j++) {
                var floatGridPos = getGridPosition(floatCluster[i][j].x, floatCluster[i][j].y);
                _bugs[floatGridPos.y][floatGridPos.x] = null;
                
                floatCluster[i][j].drop(); 

            }
                
        }

        return true;
    }
    
    this.shootBug = function(x, y) {
        if(!_current || _this.lockInput)
            return;
        _this.lockInput = true;
        _currentAngle = EHDI.NumberUtil.radianToDegree(Math.atan2(this.globalPosY-y, x - this.globalPosX));
        _currentAngle = Math.abs(_currentAngle);
        if (Math.abs(_currentAngle) < 8) {
            _currentAngle = 8;
        } else if (Math.abs(_currentAngle) > 172) {
                _currentAngle = 172;
        }
        
        EHDI.GAME.soundManager.playSFX("shoot");
        _hand.texture = EHDI.Assets.images["bugout_gizmohand_release"];
        _current.rotation = -EHDI.NumberUtil.degreeToRadian(_currentAngle + 90);
        _current.velocityX = _speed * Math.cos(EHDI.NumberUtil.degreeToRadian(_currentAngle));
        _current.velocityY = _speed * -1 * Math.sin(EHDI.NumberUtil.degreeToRadian(_currentAngle));
    }
    
    var currentBugUpdate = function(dt) {
        var updateSuccess = false;
        if(EHDI.GAME.pauseButton.isPaused)
            return;
        if(!_current)
            return;
    if(_current.velocityX != 0 && _current.velocityY != 0) {
            _prevPosX = _current.position.x;
            _prevPosY = _current.position.y;
            _current.position.x += 1 / 60 * _current.velocityX;
            _current.position.y += 1 / 60 * _current.velocityY;
            
            if(_current.x <= 30) {
                _currentAngle = 180 - _currentAngle;
                _current.rotation = -EHDI.NumberUtil.degreeToRadian(_currentAngle + 90);
                _current.velocityX = _speed * Math.cos(EHDI.NumberUtil.degreeToRadian(_currentAngle));
                _current.velocityY = _speed * -1 * Math.sin(EHDI.NumberUtil.degreeToRadian(_currentAngle));
                _current.x = 30;
            } else if(_current.x >= _limit) {
                _currentAngle = 180 - _currentAngle;
                _current.rotation = -EHDI.NumberUtil.degreeToRadian(_currentAngle + 90);
                _current.velocityX = _speed * Math.cos(EHDI.NumberUtil.degreeToRadian(_currentAngle));
                _current.velocityY = _speed * -1 * Math.sin(EHDI.NumberUtil.degreeToRadian(_currentAngle));
                _current.x = _limit;
            }
            
            if(_current.y < 30) {
                _current.y = 30;
                updateSuccess = snapBubble();
            }
            if(!updateSuccess) {
            var snap = false;
               for(var i = 0; i < _bugs.length; i++) {
                   for (var j = 0; j < _bugs[i].length; j++) {
                        var tile = _bugs[i][j];

                        if(!tile) {
                            continue;
                        }

                        var coord = getTileCoordinate(j, i);
                        if(circleIntersection(_current.x, _current.y, coord.x, coord.y)) {
                            snap = true;
                            updateSuccess = snapBubble();
                            if(updateSuccess) {
                                break;
                            }
                        }
                    }
                    if(updateSuccess) break;
                }
                if(!updateSuccess && snap) {
                    _current.position.x = _prevPosX -  1 / 60 * _current.velocityX;
                    _current.position.y = _prevPosY -  1 / 60 * _current.velocityY; 
                    snapBubble();
                }
            } 
        }
    }
    
    EHDI.GAME.updateManager.addFrameListener(currentBugUpdate);

    this.dispose = function() {
        EHDI.GAME.updateManager.removeFrameListener(currentBugUpdate);
    }
    
}

EHDI.components.BugManager.prototype = Object.create(EHDI.aka.Container.prototype);
